import { render, staticRenderFns } from "./ProposePriceModal.vue?vue&type=template&id=5667916e&scoped=true&"
import script from "./ProposePriceModal.vue?vue&type=script&lang=js&"
export * from "./ProposePriceModal.vue?vue&type=script&lang=js&"
import style0 from "./ProposePriceModal.vue?vue&type=style&index=0&id=5667916e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667916e",
  null
  
)

export default component.exports